import buildingIcon from '@/assets/img/right-click-menu/building.svg'
import settingsIcon from '@/assets/img/right-click-menu/settings.svg'
import addIcon from '@/assets/img/right-click-menu/add.svg'
import editIcon from '@/assets/img/right-click-menu/edit.svg'
import copyIcon from '@/assets/img/right-click-menu/copy.svg'
import deleteIcon from '@/assets/img/right-click-menu/delete.svg'
import viewIcon from '@/assets/img/right-click-menu/view.svg'
import mapIcon from '@/assets/img/right-click-menu/map.svg'

export const RIGHT_CLICK_MENU_ICONS = Object.freeze({
  building: {
    path: buildingIcon,
    alt: '物件',
  },
  settings: {
    path: settingsIcon,
    alt: '設定',
  },
  add: {
    path: addIcon,
    alt: '追加',
  },
  edit: {
    path: editIcon,
    alt: '編集',
  },
  copy: {
    path: copyIcon,
    alt: 'コピー',
  },
  delete: {
    path: deleteIcon,
    alt: '削除',
  },
  view: {
    path: viewIcon,
    alt: '確認',
  },
  map: {
    path: mapIcon,
    alt: 'マップ',
  },
})
